$(document).ready(function(){
  
  var modal = document.querySelector(".modal");
  var trigger = document.querySelector('.product__items');
  var closeButton = document.querySelector(".close-button");
  
  function toggleModal() {
    modal.classList.toggle("show-modal");
    document.body.classList.add('model-open')
  }
  function windowOnClick(event) {
    if (event.target === modal) {
      document.body.classList.remove('model-open')
      toggleModal();
    }
  }
  $('.product__media-list .product__items').on('click',function(){
    var index = $(this).data('index');
    $('.product-media').slick('slickGoTo', index - 1)
    setTimeout(()=>{
      toggleModal();
    },200)
  })
  closeButton.addEventListener("click", toggleModal);
  window.addEventListener("click", windowOnClick);

  $('.product-media').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.product-thumbnail'
  })    
  $('.product-thumbnail').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-media',
    dots: false,
    centerMode: false,
    infinite: true,
    arrows: false,
    focusOnSelect: true,
        responsive: [
      {
        breakpoint: 1041,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  if(screen.width <= 989){
  // Main Product images Slider
    // $('.new-mobile-Slider--main').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   dots: false,
    //   arrows: false,
    //   infinite: true
    // }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    //   var $progressBar = $('.progress');
    //   var $progressBarLabel = $( '.slider__label' );
    //   var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
  
    //   $('.new-mobile-Slider--main').parent().find($progressBar).css('background-size', calc + '% 100%').attr('aria-valuenow', calc );      
    //   $('.new-mobile-Slider--main').parent().find($progressBarLabel).text( calc + '% completed' );
    // });
  }
  
  $('.available-works-collection .filter-selected-option').on('click', function(){
    $(this).toggleClass('open')
    $(this).next().toggleClass('open');      
  });
  $(document).on("click", function(event) {
    var designerFilter = $(".filter-by-designer");
    if(!designerFilter.is(event.target) && designerFilter.has(event.target).length == 0) {
      $(designerFilter).find(".filter-selected-option").removeClass('open');
      $(designerFilter).find(".collection-filter-select").removeClass('open');
    }
    var collectionFilter = $(".filter-by-collection");
    if(!collectionFilter.is(event.target) && collectionFilter.has(event.target).length == 0) {
      $(collectionFilter).find(".filter-selected-option").removeClass('open');
      $(collectionFilter).find(".collection-filter-select").removeClass('open');
    }
  });
})